import { Directive, Input } from '@angular/core';

@Directive({
  selector: 'swiper-container',
})
export class SwiperContainerDirective {
  @Input() config?: any;
  @Input() init?: boolean | string;
  @Input() pagination?: boolean | string | object;
  @Input() navigation?: boolean | string | object;
  @Input() scrollbar?: boolean | string | object;
  // Add other commonly used properties if needed to suppress binding errors
}

@Directive({
  selector: 'swiper-slide',
})
export class SwiperSlideDirective {
  @Input() zoom?: boolean | string;
  @Input() lazy?: boolean | string;
}
